// SPA routes for project IFC model new/edit (JSON API is nested under /project/:id/ifc_models).
import React from "react";

const ProjectIfcModelsIndex = React.lazy(() => import("./index"));
const NewProjectIfcModel = React.lazy(() => import("./new"));
const EditProjectIfcModel = React.lazy(() => import("./edit"));
const ViewProjectIfcModel = React.lazy(() => import("./view"));

export default [
  { path: "/project/:project_id/ifc_models/:id/view", component: ViewProjectIfcModel, name: "View ProjectIfcModel" },
  { path: "/project/:project_id/ifc_models/:id/edit", component: EditProjectIfcModel, name: "Edit ProjectIfcModel" },
  { path: "/project/:project_id/ifc_models/new", component: NewProjectIfcModel, name: "New ProjectIfcModel" },
  { path: "/project/:project_id/ifc_models", component: ProjectIfcModelsIndex, name: "ProjectIfcModels" },
];
